import React, { useEffect, useState } from "react";
import {
  Box,
  Toolbar,
  CssBaseline,
  ThemeProvider,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";

import { Navigate } from "react-router-dom";

import { useTenant } from "../hooks/useTenant";
import { useAuth } from "../context/AuthContext";

import CustomAppBar from "../components/customAppBar";
import AdminDashboard from "../components/admin/adminDashboard";
import BarberDashboard from "../components/barber/barberDashboard";
import ClientDashboard from "./client/clientDashboard";
import LoadingScreen from "../shared_modules/loadingScreen";

const Dashboard = () => {
  const { tenant, status, error } = useTenant();
  const { user, logout } = useAuth();

  if (user?.role === "owner" || user?.role === "admin") {
    return <AdminDashboard />;
  }

  if (user?.role === "barber") {
    return <BarberDashboard />;
  }

  if (user?.role === "client") {
    return <ClientDashboard />;
  }

  return <LoadingScreen />;
};

export default Dashboard;
